import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({name: 'dateFormat'})
export class DateFormatPipe implements PipeTransform
{
    /**
     * Transform
     *
     * @param {string} value
     * @param {any[]} args
     * @returns {string}
     */
    transform(value: Date | string, args: any[] = []): string
    {
        const pipe = new DatePipe('en-GB');
        return pipe.transform(value, 'd/M/yyyy hh:mm a');
    }
}
